/**
 * @generated SignedSource<<8580c0ffbb038afdaa2b4a928fdd0e1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HeaderBlockedBySummary$data = {
  readonly issueDependenciesSummary: {
    readonly blockedBy: number;
  };
  readonly " $fragmentType": "HeaderBlockedBySummary";
};
export type HeaderBlockedBySummary$key = {
  readonly " $data"?: HeaderBlockedBySummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderBlockedBySummary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderBlockedBySummary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueDependenciesSummary",
      "kind": "LinkedField",
      "name": "issueDependenciesSummary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blockedBy",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "0e74c6559ea11860646d36b78eeadf79";

export default node;
